"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t="large",e="medium",o="small",E={[t]:t,[e]:e,[o]:o};exports.LARGE=t;exports.MEDIUM=e;exports.ROUNDED_CORNER=E;exports.SMALL=o;
